// @charset "utf-8";
export default {
    myStrategy: {// 我的策略
        createdStrategy: {// 我创建的策略
            strategyBacktestPage: 'backtest_mine.type1',  // 点击策略回测分页
            backtestOncePage: 'backtest_mine.type2',  // 点击回测一下分页
            search: 'backtest_mine.search1',  // 搜索
            delete: 'backtest_mine.delete',  // 点击删除
            deleteOk: 'backtest_mine.delete.1',  // 删除-确认
            deleteCancel: 'backtest_mine.delete.0',  // 删除-取消
            subscribe: 'backtest_mine.sub.1',  // 订阅
            cancelSubscribe: 'backtest_mine.sub.0',  // 取消订阅
            inStrategyDetails: 'backtest_mine.wdcl',  // 进入策略报告页
            inBacktestOnce: 'backtest_mine.hcyx' // 进入回测一下保存页
        },
        collectStrategy: {// 我收藏的策略
            search: 'backtest_mine.search2',  // 搜索
            inStrategyDetails: 'backtest_mine.sccl',  // 进入策略报告页
            cancelCollect: 'backtest_mine.qxsc',  // 取消收藏
            cancelCollectOk: 'backtest_mine.qxsc.1',  // 取消收藏-确认
            cancelCollectCancel: 'backtest_mine.qxsc.0' // 取消收藏-取消
        },
        takeDiscuss: {// 参与的讨论
            receiveDiscuss: 'backtest_mine.comment1',  // 点击收到的评论
            sendDiscuss: 'backtest_mine.comment2' // 点击发出的评论
        },
        // scrollBar: 'backtest_5aab2461_668', // 滚动条拉到低
        pageAccess: 'backtest_mine' // 页面访问
    },
    eventEvaluation: {// 事件评测
        modifyQuestion: 'backtest_sjhc.query',  // 修改事件
        modifySubject: 'backtest_sjhc.target',  // 修改标的
        holdingCycle: 'backtest_sjhc.duration',  // 持股周期
        startDate: 'backtest_sjhc.startdate',  // 回测开始时间
        endDate: 'backtest_sjhc.enddate',  // 回测结束时间
        startUpBacktest: 'backtest_sjhc.start',  // 启动回测
        hotBacktest: 'backtest_sjhc.hot',  // 点击热门回测
        // scrollBar: 'backtest_5aab55de_242', // 滚动条拉到低
        pageAccess: 'backtest_sjhc' // 页面访问
    },
    strategySquare: {// 策略广场
        search: 'backtest_square.search',  // 搜索
        sort: {// 排序
            'hot': 'backtest_square.hot',
            'profit': 'backtest_square.profit',
            'winRate': 'backtest_square.success',
            'createTime': 'backtest_square.new',
            'gain': 'backtest_square.month'
        },
        collect: 'backtestsquare.sc.1',  // 收藏
        collectCancel: 'backtest_square.sc.0',  // 取消收藏
        todayStockOpen: 'backtest_square.jrxg.1',  // 今日选股展开
        todayStockClose: 'backtest_square.jrxg.0',  // 今日选股关闭
        inStrategyDetails: 'backtest_square.clbg',  // 点击进入策略
        // goPage: 'backtest_square.',  // 翻页
        // scrollBar: 'backtest_5aab23f7_683', // 滚动条拉到低
        pageAccess: 'backtest_square' // 页面访问
    },
    strategyDetails: {// 策略报告（详情）
        strategyParam: {// 策略参数面板
            modifyParam: 'backtest_square.modify',  // 修改参数
            release: 'backtest_square.publish' // 发布
        },
        profitChart: {// 累计收益图
            zoomSwitch: 'backtest_square.graph.daterange',  // 缩放切换
            timingOption: 'backtest_square.graph.timing',  // 择时选项
            startDate: 'backtest_square.graph.startdate',  // 开始时间修改
            endDate: 'backtest_square.graph.enddate' // 结束时间修改
        },
        iwencai: 'backtest_square.iwencai',
        pickStockDate: 'backtest_square.xuangu',
        upsDownsChart: {// 涨跌分布图
            timingOption: 'backtest_square.pie.timing',  // 择时选项
            cycleOption: 'backtest_square.pie.duration' // 周期选择
        },
        history: {// 历史明细查询
            startDate: 'backtest_square.list.startdate',  // 开始时间修改
            endDate: 'backtest_square.list.enddate',  // 结束时间修改
            timingOption: 'backtest_square.list.timing',  // 择时选项
            cycleOption: 'backtest_square.list.duration', // 周期选择
            export: 'backtest_square.list.export'
        },
        strategyDiscuss: {// 策略评论
            comment: 'backtest_square.comment',  // 评论
            reply: 'backtest_square.reply' // 回复
        },
        pageAccess: 'backtest_square' // 页面访问
    },
    strategyBacktest: {// 策略回测
        strategyParam: {// 策略参数面板
            modifyQuestion: 'backtest_clhc.query',  // 修改问句
            holdingCycle: 'backtest_clhc.duration',  // 持股周期
            startDate: 'backtest_clhc.startdate',  // 回测开始时间
            endDate: 'backtest_clhc.enddate',  // 回测结束时间
            startUpBacktest: 'backtest_clhc.start',  // 启动回测
            holdingNumber: 'backtest_clhc.stocknum',  // 持股数
            marketTimingTrade: 'backtest_clhc.timing.1',  // 点击切换市场择时交易
            commonRuleTrade: 'backtest_clhc.timing.0' // 点击切换普通规则交易
        },
        commonRuleTrade: {// 普通规则交易
            targetProfit: {// 止盈
                riseRapidly: 'backtest_clhc.cg', // 冲高
                fall: 'backtest_clhc.hl' // 回落
            },
            stopProfit: 'backtest_clhc.zs' // 止损
        },
        marketTimingTrade: {// 市场择时交易
            strong: {// 强势
                targetProfit: {// 止盈
                    riseRapidly: 'backtest_clhc.radical.cg',  // 冲高
                    fall: 'backtest_clhc.radical.hl' // 回落
                },
                stopProfit: 'backtest_clhc.radical.zs' // 止损
            },
            weak: {// 弱势
                targetProfit: {// 止盈
                    riseRapidly: 'backtest_clhc.conservative.cg',  // 冲高
                    fall: 'backtest_clhc.conservative.hl' // 回落
                },
                stopProfit: 'backtest_clhc.conservative.zs',  // 止损
                positionControl: 'backtest_clhc.position' // 仓位控制
            }
        },
        timingSignal: {// 择时信号
            openPanel: 'backtest_clhc.signal',  // 打开面板
            selectSignal: 'backtest_clhc.signal.1',  // 选择信号
            deleteSignal: 'backtest_clhc.signal.0',  // 删除信号
            selectAll: 'backtest_clhc.signal.all' // 全选
        },
        saveRelease: 'backtest_clhc.save',  // 点击保存发布
        releaseBacktestReport: {// 发布回测报告
            // modifyName: 'backtest_5aab52c9_339',  // 修改报告名称
            // modifyLogic: 'backtest_5aab52d5_789',  // 修改逻辑说明
            // modifyLabel: 'backtest_5aab52e5_938',  // 修改策略标签
            saveDraft: 'backtest_clhc.save.1',  // 点击保存草稿
            releaseStrategy: 'backtest_clhc.save.2' // 点击发布策略
        },
        iwencai: 'backtest_clhc.iwencai',
        pickStockDate: 'backtest_clhc.xuangu',
        // saveAfterRelease: {// 保存后点击发布
        //     ok: 'backtest_5aab52f3_263',  // 确定
        //     cancel: 'backtest_5aab5300_438' // 取消
        // },
        profitChart: {// 累计收益图
            zoomSwitch: 'backtest_clhc.graph.daterange',  // 缩放切换
            timingOption: 'backtest_clhc.graph.timing',  // 择时选项
            startDate: 'backtest_clhc.graph.startdate',  // 开始时间修改
            endDate: 'backtest_clhc.graph.enddate' // 结束时间修改
        },
        upsDownsChart: {// 涨跌分布图
            timingOption: 'backtest_clhc.pie.timing',  // 择时选项
            cycleOption: 'backtest_clhc.pie.duration' // 周期选择
        },
        history: {// 历史明细查询
            startDate: 'backtest_clhc.list.startdate',  // 开始时间修改
            endDate: 'backtest_clhc.list.enddate',  // 结束时间修改
            timingOption: 'backtest_clhc.list.timing',  // 择时选项
            cycleOption: 'backtest_clhc.list.duration',
            export: 'backtest_clhc.list.export' // 周期选择
        },
        // scrollBar: 'backtest_5aab2397_374', // 滚动条拉到低
        pageAccess: 'backtest_clhc' // 页面访问
    },
    backtestOnce: {// 回测一下
        strategyParam: {// 策略参数面板
            modifyQuestion: 'backtest_hcyx.query',  // 修改问句
            holdingCycle: 'backtest_hcyx.duration',  // 持股周期
            startDate: 'backtest_hcyx.startdate',  // 回测开始时间
            endDate: 'backtest_hcyx.enddate',  // 回测结束时间
            startUpBacktest: 'backtest_hcyx.start' // 启动回测
        },
        upsDownsChart: {// 涨跌分布图
            cycleOption: 'backtest_hcyx.pie.duration' // 周期选择
        },
        history: {// 历史明细查询
            startDate: 'backtest_hcyx.list.startdate',  // 开始时间修改
            endDate: 'backtest_hcyx.list.enddate',  // 结束时间修改
            cycleOption: 'backtest_hcyx.list.duration', // 周期选择
            export: 'backtest_hcyx.list.export'
        },
        hotBacktest: 'backtest_hcyx.hot',  // 点击热门回测
        backtestResult: {// 回测结果页
            save: 'backtest_hcyx.save.1',  // 保存
            saveCancel: 'backtest_hcyx.save.0' // 取消保存
        },
        // scrollBar: 'backtest_5ab09e6d_335', // 滚动条拉到低
        pageAccess: 'backtest_hcyx' // 页面访问
    }
}
// export default {
//     myStrategy: {// 我的策略
//         createdStrategy: {// 我创建的策略
//             strategyBacktestPage: 'backtest_5aab560a_991',  // 点击策略回测分页
//             backtestOncePage: 'backtest_5aab5616_327',  // 点击回测一下分页
//             search: 'backtest_5aab5622_380',  // 搜索
//             delete: 'backtest_5aab562d_988',  // 点击删除
//             deleteOk: 'backtest_5aab5639_327',  // 删除-确认
//             deleteCancel: 'backtest_5aab5644_673',  // 删除-取消
//             subscribe: 'backtest_5aab5661_838',  // 订阅
//             cancelSubscribe: 'backtest_5aab5697_483',  // 取消订阅
//             inStrategyDetails: 'backtest_5aab566c_650',  // 进入策略报告页
//             inBacktestOnce: 'backtest_5aab5677_262' // 进入回测一下保存页
//         },
//         collectStrategy: {// 我收藏的策略
//             search: 'backtest_5aab56a7_277',  // 搜索
//             cancelCollect: 'backtest_5aab56b1_808',  // 取消收藏
//             cancelCollectOk: 'backtest_5aab56bc_713',  // 取消收藏-确认
//             cancelCollectCancel: 'backtest_5aab56c7_420' // 取消收藏-取消
//         },
//         takeDiscuss: {// 参与的讨论
//             receiveDiscuss: 'backtest_5aab2438_905',  // 点击收到的评论
//             sendDiscuss: 'backtest_5aab244f_745' // 点击发出的评论
//         },
//         scrollBar: 'backtest_5aab2461_668', // 滚动条拉到低
//         pageAccess: 'backtest_5b20d439_659' // 页面访问
//     },
//     eventEvaluation: {// 事件评测
//         modifyQuestion: 'backtest_5aab554e_994',  // 修改事件
//         modifySubject: 'backtest_5aab555c_883',  // 修改标的
//         holdingCycle: 'backtest_5aab5585_151',  // 持股周期
//         startDate: 'backtest_5aab55b9_500',  // 回测开始时间
//         endDate: 'backtest_5aab55c4_620',  // 回测结束时间
//         startUpBacktest: 'backtest_5aab241b_107',  // 启动回测
//         hotBacktest: 'backtest_5aab55d0_798',  // 点击热门回测
//         scrollBar: 'backtest_5aab55de_242', // 滚动条拉到低
//         pageAccess: 'backtest_5b20d425_898' // 页面访问
//     },
//     strategySquare: {// 策略广场
//         search: 'backtest_5aab5501_530',  // 搜索
//         sort: 'backtest_5aab23d4_713',  // 排序
//         collect: 'backtest_5aab550e_32',  // 收藏
//         collectCancel: 'backtest_5aab5518_430',  // 取消收藏
//         todayStockOpen: 'backtest_5aab5525_150',  // 今日选股展开
//         todayStockClose: 'backtest_5aab5530_822',  // 今日选股关闭
//         inStrategyDetails: 'backtest_5aab553b_819',  // 点击进入策略
//         goPage: 'backtest_5aab23e1_697',  // 翻页
//         scrollBar: 'backtest_5aab23f7_683', // 滚动条拉到低
//         pageAccess: 'backtest_5b20d40d_263' // 页面访问
//     },
//     strategyDetails: {// 策略报告（详情）
//         strategyParam: {// 策略参数面板
//             modifyParam: 'backtest_5aab5417_43',  // 修改参数
//             release: 'backtest_5aab5424_613' // 发布
//         },
//         profitChart: {// 累计收益图
//             zoomSwitch: 'backtest_5aab543a_784',  // 缩放切换
//             timingOption: 'backtest_5aab5447_634',  // 择时选项
//             startDate: 'backtest_5aab5454_930',  // 开始时间修改
//             endDate: 'backtest_5aab5463_808' // 结束时间修改
//         },
//         upsDownsChart: {// 涨跌分布图
//             timingOption: 'backtest_5aab5471_83',  // 择时选项
//             cycleOption: 'backtest_5aab547d_433' // 周期选择
//         },
//         history: {// 历史明细查询
//             startDate: 'backtest_5aab548b_135',  // 开始时间修改
//             endDate: 'backtest_5aab5496_613',  // 结束时间修改
//             timingOption: 'backtest_5aab54a2_758',  // 择时选项
//             cycleOption: 'backtest_5aab54d4_923' // 周期选择
//         },
//         strategyDiscuss: {// 策略评论
//             comment: 'backtest_5aab54e3_197',  // 评论
//             reply: 'backtest_5aab54ed_659' // 回复
//         },
//         pageAccess: 'backtest_5b20d450_29' // 页面访问
//     },
//     strategyBacktest: {// 策略回测
//         strategyParam: {// 策略参数面板
//             modifyQuestion: 'backtest_5aab3bb1_132',  // 修改问句
//             holdingCycle: 'backtest_5aab3be7_240',  // 持股周期
//             startDate: 'backtest_5aab3bfc_133',  // 回测开始时间
//             endDate: 'backtest_5aab3c0d_352',  // 回测结束时间
//             startUpBacktest: 'backtest_5aab234f_584',  // 启动回测
//             holdingNumber: 'backtest_5aab3c1c_948',  // 持股数
//             marketTimingTrade: 'backtest_5aab3c2b_563',  // 点击切换市场择时交易
//             commonRuleTrade: 'backtest_5aab3c38_382' // 点击切换普通规则交易
//         },
//         commonRuleTrade: {// 普通规则交易
//             targetProfit: {// 止盈
//                 riseRapidly: 'backtest_5aab3c49_343', // 冲高
//                 fall: 'backtest_5aab3c5c_643' // 回落
//             },
//             stopProfit: 'backtest_5aab3c6c_693' // 止损
//         },
//         marketTimingTrade: {// 市场择时交易
//             strong: {// 强势
//                 targetProfit: {// 止盈
//                     riseRapidly: 'backtest_5aab3c79_989',  // 冲高
//                     fall: 'backtest_5aab3c87_212' // 回落
//                 },
//                 stopProfit: 'backtest_5aab522a_692' // 止损
//             },
//             weak: {// 弱势
//                 targetProfit: {// 止盈
//                     riseRapidly: 'backtest_5aab5239_331',  // 冲高
//                     fall: 'backtest_5aab5246_681' // 回落
//                 },
//                 stopProfit: 'backtest_5aab5258_112',  // 止损
//                 positionControl: 'backtest_5aab5265_333' // 仓位控制
//             }
//         },
//         timingSignal: {// 择时信号
//             openPanel: 'backtest_5aab5274_612',  // 打开面板
//             selectSignal: 'backtest_5aab528f_855',  // 选择信号
//             deleteSignal: 'backtest_5aab529d_219',  // 删除信号
//             selectAll: 'backtest_5aab52ad_951' // 全选
//         },
//         saveRelease: 'backtest_5aab52bb_788',  // 点击保存发布
//         releaseBacktestReport: {// 发布回测报告
//             modifyName: 'backtest_5aab52c9_339',  // 修改报告名称
//             modifyLogic: 'backtest_5aab52d5_789',  // 修改逻辑说明
//             modifyLabel: 'backtest_5aab52e5_938',  // 修改策略标签
//             saveDraft: 'backtest_5aab2382_435',  // 点击保存草稿
//             releaseStrategy: 'backtest_5aab236d_608' // 点击发布策略
//         },
//         saveAfterRelease: {// 保存后点击发布
//             ok: 'backtest_5aab52f3_263',  // 确定
//             cancel: 'backtest_5aab5300_438' // 取消
//         },
//         profitChart: {// 累计收益图
//             zoomSwitch: 'backtest_5aab530d_209',  // 缩放切换
//             timingOption: 'backtest_5aab531a_143',  // 择时选项
//             startDate: 'backtest_5aab5325_833',  // 开始时间修改
//             endDate: 'backtest_5aab5359_682' // 结束时间修改
//         },
//         upsDownsChart: {// 涨跌分布图
//             timingOption: 'backtest_5aab539f_968',  // 择时选项
//             cycleOption: 'backtest_5aab53ad_814' // 周期选择
//         },
//         history: {// 历史明细查询
//             startDate: 'backtest_5aab53c3_89',  // 开始时间修改
//             endDate: 'backtest_5aab53d0_29',  // 结束时间修改
//             timingOption: 'backtest_5aab53df_653',  // 择时选项
//             cycleOption: 'backtest_5aab53ec_835' // 周期选择
//         },
//         scrollBar: 'backtest_5aab2397_374', // 滚动条拉到低
//         pageAccess: 'backtest_5b20d3df_680' // 页面访问
//     },
//     backtestOnce: {// 回测一下
//         strategyParam: {// 策略参数面板
//             modifyQuestion: 'backtest_5aab3b15_532',  // 修改问句
//             holdingCycle: 'backtest_5aab3b22_983',  // 持股周期
//             startDate: 'backtest_5aab3b37_331',  // 回测开始时间
//             endDate: 'backtest_5aab3b44_961',  // 回测结束时间
//             startUpBacktest: 'backtest_5aab22e0_406' // 启动回测
//         },
//         upsDownsChart: {// 涨跌分布图
//             cycleOption: 'backtest_5aab3b51_654' // 周期选择
//         },
//         history: {// 历史明细查询
//             startDate: 'backtest_5aab3b61_489',  // 开始时间修改
//             endDate: 'backtest_5aab3b6d_654',  // 结束时间修改
//             cycleOption: 'backtest_5aab3b79_693' // 周期选择
//         },
//         hotBacktest: 'backtest_5aab3b8a_431',  // 点击热门回测
//         backtestResult: {// 回测结果页
//             save: 'backtest_5aab22ef_56',  // 保存
//             saveCancel: 'backtest_5aab3b98_239' // 取消保存
//         },
//         scrollBar: 'backtest_5ab09e6d_335', // 滚动条拉到低
//         pageAccess: 'backtest_5b20d3cb_303' // 页面访问
//     },
//     navigationBar: {// 导航栏
//         home: 'backtest_5aa8d520_374',  // 首页
//         backtestOnce: 'backtest_5aab22cc_934',  // 回测一下
//         strategyBacktest: 'backtest_5aab2325_767',  // 策略回测
//         strategySquare: 'backtest_5aab23c4_988',  // 策略广场
//         eventEvaluation: 'backtest_5aab2406_897',  // 事件评测
//         myStrategy: 'backtest_5aab242b_623' // 我的策略
//     },
//     totalPlatformAccess: 'backtest_5b20d46c_372' // 平台总访问量
// }



// WEBPACK FOOTER //
// ./src/lib/buriedPoint.js